import AssessmentOverviewTargetMaturityBreakdown from "@features/assessments-feature/components/overview/AssessmentOverviewTargetMaturityBreakdown";
import Box from "@mui/material/Box";

const TargetMaturityBreakdownExport = () => {
  return (
    <Box
      className={"assessment-break"}
      sx={{ "& .MuiCardContent-root": { height: 540 } }}
    >
      <AssessmentOverviewTargetMaturityBreakdown />
    </Box>
  );
};

export default TargetMaturityBreakdownExport;
